<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-blue-400 hover:text-blue-600 fill-blue-400" :href="route('category')"><icon name="home" class="w-6 h-6 -mt-1 mr-2 inline-block" />Inmueble</inertia-link>
      <span class=" font-medium">/</span> Crear: {{ form.nombre }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <!-- <h2 class=" w-full">Informacion</h2> -->
          <!-- =""; -->
            <text-input v-model="form.nombre" :error="form.errors.nombre" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre de la propiedad" />
             <select-input v-model="form.ID_duenio" :error="form.errors.ID_duenio" class="pr-6 pb-8 w-full lg:w-1/2" label="Propietario">
                 <option :value="null" />
                 <option v-for="user in users" :key="user.ID" :value='user.ID'>{{user.usuario}} - {{user.nombre}}</option>
            </select-input>
           <select-input v-model="form.operacion" :error="form.errors.operacion" class="pr-6 pb-8 w-full lg:w-1/2" label="Tipo de operacion">
              <option :value="null" />
               <option value='1'>Alquiler</option>
              <option value='2'>Venta</option>
              <option value='3'>Transitorio</option>
          </select-input>
          <select-input v-model="form.tipo_inmueble" :error="form.errors.tipo_inmueble" class="pr-6 pb-8 w-full lg:w-1/2" label="Tipo Inmueble">
              <option :value="null" />
              <option value='1'>Casa/Cabaña</option>
              <option value='2'>Apartamento</option>
              <option value='3'>Hotel/Posada</option>
              <option value='4'>Hostel/Camping</option>
              <option value='5'>Terreno</option>
              <option value='6'>Chacra</option>
          </select-input>
          <select-input v-model="form.zona" :error="form.errors.zona" class="pr-6 pb-8 w-full lg:w-1/2" label="Zona">
              <option :value="null" />
              <option value='1'>La Pedrera</option>
              <option value='3'>Punta Rubia</option>
              <option value='2'>San Sebastián</option>
              <option value='5'>Arachania</option>
              <option value='4'>Santa Isabel</option>
              <option value='6'>Tajamares de La Pedrera</option>
              <option value='11'>La Serena Golf</option>
              <option value='7'>San Antonio</option>
              <option value='8'>Pueblo Nuevo</option>
              <option value='9'>Atlántica</option>
              <option value='10'>Oceanía del Polonio</option>
              <option value='12'>La Paloma</option>
              <option value='13'>Zona rural</option>
          </select-input>
          <text-input v-model="form.mapongo" placeholder="-34.591327,-54.127965" :error="form.errors.mapongo" class="pr-6 pb-8 w-full lg:w-1/2" label="Coordenadas de Mapa" />
          <a href='http://www.google.com/maps?ll=-34.591327,-54.127965&spn=0.007092,0.016512&t=m&z=17' class="map" target='_blank'>Codigo del mapa</a><br>

            
             <h2 class=" w-full">Informacion de Propiedad y Contacto</h2>
               <div class="rich-content mb-4">
                <label class="mb-2" for="">Descripcion</label>
                <vue-editor class=" w-full" v-model="form.descripcion" :editor-toolbar="customToolbar" :error="form.errors.descripcion" />
              
              </div>
              <div class="rich-content">
                <label class="mb-2" for="">Descripcion Corta</label>
                <span class="text-red-400 text-sm" v-if="form.errors.descripcion_corta">{{ form.errors.descripcion_corta }}</span>
                <vue-editor class="w-full" v-model="form.descripcion_corta" :error="form.errors.descripcion_corta" :editor-toolbar="customToolbar"  />
              </div>
             
              <!-- <text-input v-model="form.descripcion"  class="pr-6 pb-8 w-full lg:w-1/2" label="Descripción larga" />            
              <text-input v-model="form.descripcion_corta"  class="pr-6 pb-8 w-full lg:w-1/2" label="Descripción corta" />             -->
              <!-- <text-input v-model="form.informe_contacto" :error="form.errors.informe_contacto" class="pr-6 pb-8 w-full lg:w-1/2" label="Información de contacto" />             -->
              <div class="rich-content">
                <label class="mb-2" for="">Información de contacto</label>
                <vue-editor class="w-full" v-model="form.informe_contacto" :error="form.errors.informe_contacto" :editor-toolbar="customToolbar"  />
              </div>
              
              <text-input  v-model="form.email_contacto" :error="form.errors.email_contacto" class="pr-6 pb-8 w-full lg:w-1/2" label="Email de contacto" />            
              <text-input v-model="form.whatsapp" :error="form.errors.whatsapp" class="pr-6 pb-8 w-full lg:w-1/2" label="Whatsapp" />

<!-- 
             $table->string('nombre', 200);
            $table->integer('ID_duenio'); -->
            <!-- <text-area-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full lg:w-1/2" label="Descripcion" />
            <text-area-input v-model="form.en_description" :error="form.errors.en_description" class="pr-6 pb-8 w-full lg:w-1/2" label="Descripcion en ingles" /> -->
                
        </div>
         <div v-if="form.operacion === '1'" class="p-8 -mr-6 -mb-8 flex flex-wrap">      
            <h2 class=" w-full">Comodidades</h2>
            <select-input v-model="form.capacidad" :error="form.errors.capacidad" class="pr-6 pb-8 w-full lg:w-1/2" label="Capacidad">
              <option value='1'>1</option>
              <option value="2">2</option>
              <option value='3'>3</option>
              <option value='4'>4</option>
              <option value='5'>5</option>
              <option value='6'>6</option>
              <option value='7'>7</option>
              <option value='8'>8</option>
              <option value='9'>9</option>
              <option value='10'>10</option>
              <option value='11'>11</option>
              <option value='12'>12</option>
            </select-input>
            <select-input v-model="form.dormitorios" :error="form.errors.dormitorios" class="pr-6 pb-8 w-full lg:w-1/2" label="Dormitorios">
              <option value='1'>1</option>
              <option value='2'>2</option>
              <option value='3'>3</option>
              <option value='4'>4</option>
              <option value='5'>5</option>
            </select-input>
            <select-input v-model="form.banios" :error="form.errors.banios" class="pr-6 pb-8 w-full lg:w-1/2" label="Baños">
              <option value='1'>1</option>
              <option value='2'>2</option>
              <option value='3'>3</option>
              <option value='4'>4</option>
              <option value='5'>5</option>
            </select-input>
            <select-input v-model="form.banio_suite" :error="form.errors.banio_suite" class="pr-6 pb-8 w-full lg:w-1/2" label="Baños en Suite">
              <option value='0'>No</option>
              <option value='1'>1</option>
              <option value='2'>2</option>
              <option value='3'>3</option>
              <option value='4'>4</option>
              <option value='5'>5</option>
            </select-input>
            <select-input v-model="form.cubiertos" :error="form.errors.cubiertos" class="pr-6 pb-8 w-full lg:w-1/2" label="Cubiertos y vajillas">
              <option value='1'>1 persona</option>
              <option value='2'>2 personas</option>
              <option value='3'>3 personas</option>
              <option value='4'>4 personas</option>
              <option value='5'>5 personas</option>
              <option value='6'>6 personas</option>
              <option value='7'>7 personas</option>
              <option value='8'>8 personas</option>
              <option value='69'>más de 8</option>
            </select-input>
            <label class="mr-6 mb-4  select-none flex items-center" for="sabanas">
            <input id="sabanas" v-model="form.errors.sabanas" class="mr-1" type="checkbox" />
            <span class="">Incluye sabanas</span>
             </label>
            <label class="mr-6 mb-4 select-none flex items-center" for="mascotas">
              <input id="mascotas" v-model="form.mascotas" class="mr-1" type="checkbox" />
              <span class="text-check">Acepta mascotas</span>
            </label>
          <h2 class=" w-full">Equipamiento</h2>
           <label class="mr-6 mb-4 select-none flex items-center" for="wifi">
            <input id="wifi" v-model="form.wifi" class="mr-1" type="checkbox" />
            <span class="text-check">Wifi</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="parrillero">
            <input id="parrillero" v-model="form.parrillero" class="mr-1" type="checkbox" />
            <span class="text-check">Parrillero</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="jardin">
            <input id="jardin" v-model="form.jardin" class="mr-1" type="checkbox" />
            <span class="text-check">jardin</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="estufa">
            <input id="estufa" v-model="form.estufa" class="mr-1" type="checkbox" />
            <span class="text-check">estufa</span>
          </label>
          <label class="mr-6  mb-4 select-none flex items-center" for="cerco">
            <input id="cerco" v-model="form.cerco" class="mr-1" type="checkbox" />
            <span class="text-check">cerco</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="jacuzzi">
            <input id="jacuzzi" v-model="form.jacuzzi" class="mr-1" type="checkbox" />
            <span class="text-check">jacuzzi</span>
          </label>
          <label class="mr-6  mb-4 select-none flex items-center" for="alarma">
            <input id="alarma" v-model="form.alarma" class="mr-1" type="checkbox" />
            <span class="text-check">alarma</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="rejas">
            <input id="rejas" v-model="form.rejas" class="mr-1" type="checkbox" />
            <span class="text-check">rejas</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="lavarropas">
            <input id="lavarropas" v-model="form.lavarropas" class="mr-1" type="checkbox" />
            <span class="text-check">lavarropas</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="cochera">
            <input id="cochera" v-model="form.cochera" class="mr-1" type="checkbox" />
            <span class="text-check">cochera</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="postigones">
            <input id="postigones" v-model="form.postigones" class="mr-1" type="checkbox" />
            <span class="text-check">postigones</span>
          </label>
           <label class="mr-6 mb-4 select-none flex items-center" for="cofre">
            <input id="cofre" v-model="form.cofre" class="mr-1" type="checkbox" />
            <span class="text-check">cofre</span>
          </label>
          
          <h2 class=" w-full">Destaques</h2>
           <select-input v-model="form.alquiler_alta" :error="form.errors.alquiler_alta" class="pr-6 pb-8 w-full lg:w-1/2" label="Período mínimo de alquiler en alta temp.">
                         <option value='no'>No alquila</option>
                        <option value='día'>día</option>
            <option value='fin de semana'>fin de semana</option>
            <option value='semana'>semana</option>
            <option value='10 días'>10 días</option>
            <option value='quincena'>quincena</option>
            </select-input>
            <select-input v-model="form.alquiler_baja" :error="form.errors.alquiler_baja" class="pr-6 pb-8 w-full lg:w-1/2" label="Período mínimo de alquiler en baja temp.">
                      <option value='no'>No alquila</option>
                        <option value='día'>día</option>
            <option value='fin de semana'>fin de semana</option>
            <option value='semana'>semana</option>
            <option value='10 días'>10 días</option>
            <option value='quincena'>quincena</option>
            </select-input>

         <h2 class=" w-full">Categorias</h2>
           <label class="mr-6 mb-4 select-none flex items-center" for="jovenes">
            <input id="jovenes" v-model="form.jovenes" class="mr-1" type="checkbox" />
            <span class="text-check">Alquila a Jovenes</span>
          </label>

           <label class="mr-6 mb-4 select-none flex items-center" for="oceanview">
            <input id="oceanview" v-model="form.oceanview" class="mr-1" type="checkbox" />
            <span class="text-check">Vista al Mar(new)</span>
          </label>
           <label class="mr-6 mb-4 select-none flex items-center" for="featured">
            <input id="featured" v-model="form.featured" class="mr-1" type="checkbox" />
            <span class="text-check">Casa Destacada</span>
          </label>
           <label class="mr-6 mb-4 select-none flex items-center" for="cheap">
            <input id="cheap" v-model="form.cheap" class="mr-1" type="checkbox" />
            <span class="text-check">Calidad/Precio</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="architecture">
            <input id="architecture" v-model="form.architecture" class="mr-1" type="checkbox" />
            <span class="text-check">Arquitectura</span>
          </label>
          <label class="mr-6 mb-4 select-none flex items-center" for="nature">
            <input id="nature" v-model="form.nature" class="mr-1" type="checkbox" />
            <span class="text-check">Lejos del ruido</span>
          </label>

             </div>
        
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Inmueble</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import CheckboxInput from '@/Shared/CheckboxInput'
import { VueEditor } from "vue2-editor";


export default {
  metaInfo: { title: 'Crear Inmueble' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    CheckboxInput,
    VueEditor
  },
  props: {
    // filters: Object,
    users: Array,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
       customToolbar: [
      [{ header: [false, 2] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        // [
        //   { align: "" },
        //   { align: "center" },
        //   { align: "right" },
        //   { align: "justify" }
        // ],
        // ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        // [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        // [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["link"],
        ["clean"] // remove formatting button,
      ],
      form: this.$inertia.form({
        nombre: null,
        ID_duenio: '1',
        parrillero: null,
        tipo_inmueble: null,
        operacion: '1',
        zona: null,
        descripcion: ' ',
        descripcion_corta: ' ',
        informe_contacto: ' ',
        email_contacto: null,
        capacidad: '1',
        dormitorios: '1' ,
        banios: '1',
        banio_suite: 0 ,
        mascotas: null,
        sabanas: '1' ,
        estufa:null ,
        cerco:null ,
        cubiertos: '1' ,
        jacuzzi:null ,
        alarma:null ,
        rejas:null ,
        lavarropas:null ,
        cochera:null ,
        cofre:null,
        alquiler_alta: 'día',
        alquiler_baja: 'no',
        vista_mar: null,
        jovenes: null,
        superficie: 1,
        u_superficie: 1,
        superficie_c: 1,
        u_superficie_c: 1,
        mapongo: '',
        url_video: '-',
        moneda: 1,
        plantas: 1, 
        estrellas: 5,
        desactivada: null,
        patrocinada: null,

      }),
    }
  },
  methods: {
    store() {
      this.form.transform((data) => ({
        ...data,
        informe_contacto: data.informe_contacto || '<br/>',
        parrillero: data.parrillero ? true : false,
        desactivada: data.desactivada ? true : false,
        patrocinada: data.patrocinada ? true : false,
        estufa: data.estufa ? true : false,
        cerco: data.cerco ? true : false,
        mascotas: data.mascotas ? true : false,
        jacuzzi: data.jacuzzi ? true : false,
        alarma: data.alarma ? true : false,
        rejas: data.rejas ? true : false,
        lavarropas: data.lavarropas ? true : false,
        cochera: data.cochera ? true : false,
        cofre: data.cofre ? true : false,
        vista_mar: data.vista_mar ? true : false,
        jovenes: data.jovenes ? true : false,
        superficie: data.superficie || 1,
        u_superficie: data.u_superficie || 1,
        u_superficie_c: data.superficie_c || 1,
        superficie_c: data.superficie_c || 1,
        url_video: '-',
        email_contacto_2: data.email_contacto,
        alquila_baja:  data.alquiler_baja == 'no' ? 0 : 1,
        mapongo: data.mapongo ? data.mapongo : '-',

      }))
      console.log(this.form);
      this.form.post(this.route('properties.store'))
    },
  },
}
</script>
